import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl'
import moment from 'moment'
import { range, each } from 'lodash'
import $ from 'jquery'; 

import { callApi } from '../services/fetchService'

import FaIcon from '../components/FaIcon'
import HelpAlert from '../components/HelpAlert'
import DataTable from '../components/DataTable'

import { Select, Card, Spin, message } from 'antd'
const { Option } = Select


class Report1 extends Component {

    static propTypes = {
        comboboxes: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }
    
    state = {
        year: moment().year(),
        data: null,
        loading: false
    }

    fetch = () => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'reports/1/' + this.state.year 
        }).then((data) => {
            this.setState({
                data: data,
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    componentDidUpdate() {
        if (!this.state.loading && this.state.data) {
            each(this.state.data.total, (laboratory) => {
                let tfoot = '<tfoot class="ant-table-thead"><tr><th>Total</th>'
                each(moment.months(), (month, index) => (
                    tfoot += '<th>' + (laboratory.items[index + 1] || 0) + '</th>'
                ))
                tfoot += "<th>" + laboratory.total + "</th></tr></tfoot>"
                $(".table-" + laboratory.laboratory + " table").append(tfoot)
            })
        }
    }

    onChangeYear = (value) => {
        this.setState({ year: value }, this.fetch)
    }

    render() {
        const { data, loading, year } = this.state

        const columns = [
            { title: "reports.report1.doctor", dataIndex: "name", type: "string", sorter: true },
        ]
        each(moment.months(), (month, index) => (
            columns.push({ title: month, formatTitle: false, key: month, type: "number", dataIndex: "months[" + (index + 1) + "]", sorter: true })
        ))
        columns.push({ title: "reports.report1.total", type: "number", dataIndex: "total", sorter: true })


        return (
            <div>
                <h1><FaIcon icon="chart-bar" fixedWidth /> <FormattedHTMLMessage id="reports.report1.title" /></h1>
                <div className="action-bar">
                    <Select defaultValue={year} style={{ width: 120 }} onChange={this.onChangeYear}>
                        { range(2016, moment().year() + 1).map(year => <Option key={year} value={year}>{year}</Option>) }
                    </Select>
                </div>
                <HelpAlert style={{ marginTop: '25px', marginBottom: '25px' }} message="reports.report1.helpAlert" />
                {
                    loading 
                        ? <div style={{ textAlign: 'center', marginTop: '50px' }}><Spin size="large" /></div>
                        : !data || data.data.length === 0 
                            ? <div className="message" style={{ marginTop: "45px" }}>
                                <FaIcon icon="exclamation-circle" size="8x" />
                                <br /><br />
                                <span style={{ fontSize: "35px" }}><FormattedMessage id="reports.misc.noData" /></span>
                            </div>
                            : data.data.map(laboratory => (
                                <Card title={this.props.comboboxes.byKey["laboratory"][laboratory.laboratory].value} key={laboratory.laboratory}>
                                    <DataTable columns={columns} dataSource={laboratory.items} rowKey="doctor" size="middle" className={"table-" + laboratory.laboratory} export={{ format: "landscape" }} />
                                </Card>
                            ))
                }
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes
})

export default injectIntl(connect(mapStateToProps)(Report1))


// WEBPACK FOOTER //
// ./src/views/Report1.js